"use client";

import { useEffect, useState } from "react";
import { useParams } from "next/navigation";
import dynamic from "next/dynamic";

const DynamicShopFullwidth = dynamic(
	() => import("@/components/shop/ShopFullwidth"),
	{ ssr: false }
);

export default function DepotPage() {
	const params = useParams();
	const depotSlug = params.depot;

	const [productsData, setProductsData] = useState([]);
	const [depotLabel, setDepotLabel] = useState("");
	const [loading, setLoading] = useState(true);
	const [notFound, setNotFound] = useState(false);

	const path = depotSlug ? `/depozite/${depotSlug}` : "/depozite";

	useEffect(() => {
		if (!depotSlug) return;

		async function fetchDepotProducts() {
			setLoading(true);
			setNotFound(false);
			try {
				const depotRes = await fetch(`/api/depozite?slug=${depotSlug}`);
				if (!depotRes.ok) { setNotFound(true); return; }

				const depotData = await depotRes.json();
				if (!depotData.supplier) { setNotFound(true); return; }

				setDepotLabel(`Depozit ${depotSlug.toUpperCase()}`);

				const productsRes = await fetch(
					`/api/products?supplier=${encodeURIComponent(depotData.supplier)}&limit=100`
				);
				const data = await productsRes.json();
				setProductsData(data.products || []);
			} catch (e) {
				console.error("Eroare la încărcarea depozitului:", e);
			} finally {
				setLoading(false);
			}
		}

		fetchDepotProducts();
	}, [depotSlug]);

	if (loading) {
		return (
			<div style={{ minHeight: "400px", display: "flex", alignItems: "center", justifyContent: "center" }}>
				<p>Se încarcă produsele...</p>
			</div>
		);
	}

	if (notFound) {
		return (
			<div style={{ minHeight: "400px", display: "flex", alignItems: "center", justifyContent: "center" }}>
				<p>Depozitul nu a fost găsit.</p>
			</div>
		);
	}

	return (
		<>
			<div className="tf-page-title">
				<div className="container-full">
					<div className="heading text-center">
						Produse din {depotLabel}
					</div>
					<p className="text-center" style={{ color: "#666", marginTop: 8, fontSize: 14 }}>
						{productsData.length} produse
					</p>
				</div>
			</div>
			{(depotSlug?.toLowerCase() === "e" ||
						depotSlug?.toLowerCase() === "h") && <BannerMinimumPrice />}
			<DynamicShopFullwidth productsData={productsData} />
		</>
	);
}


const BannerMinimumPrice = () => { 
	return (
			<div className="bg-black px-4 py-2">
				<p className="m-0 text-center text-lg text-white leading-tight">
					Comanda minima pentru acest depozit este de <span>150 RON.</span>
				</p>
			</div>
	)
}